import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

const MAIN_URL = 'https://kaspreadsheet.com';

export default function Footer() {
  const { t } = useTranslation();
  const topCategories = categories.slice(0, 6);

  return (
    <footer className="bg-foreground-900 text-white rounded-t-3xl mx-4 md:mx-6 mt-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <h3 className="font-heading text-2xl md:text-3xl font-semibold mb-4">
              {t('brand')}
            </h3>
            <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-sm">
              {t('footer.tagline')}
            </p>
            <Link
              to="/allchinabuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-foreground-900 font-medium text-sm hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('footer.guide')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-semibold text-white/70 uppercase tracking-wider mb-5">
              {t('footer.categoriesTitle')}
            </h4>
            <ul className="space-y-3">
              {topCategories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50 whitespace-nowrap"
                  >
                    {t(`categories.${cat.id}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-sm font-semibold text-white/70 uppercase tracking-wider mb-5">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={MAIN_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50"
                >
                  {t('cta.spreadsheet')}
                </a>
              </li>
              <li>
                <a
                  href={MAIN_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50"
                >
                  {t('cta.buyNow')}
                </a>
              </li>
              <li>
                <Link
                  to="/allchinabuy-spreadsheet-guide"
                  className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50"
                >
                  {t('footer.guide')}
                </Link>
              </li>
              <li>
                <a
                  href="#categories"
                  className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50"
                >
                  {t('nav.categories')}
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 underline decoration-white/20 hover:decoration-white/50"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col gap-4">
          <p className="text-xs leading-relaxed text-white/30">{t('disclosure')}</p>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-6">
              <span className="text-white/30 text-xs">allchinabuyspread.wtf</span>
            </div>
            <p className="text-white/30 text-xs text-center">{t('footer.copyright')}</p>
            <div className="flex items-center gap-6">
              <Link
                to="/"
                className="text-white/30 text-xs hover:text-white/50 transition-colors duration-200 underline decoration-white/10 hover:decoration-white/30"
              >
                Home
              </Link>
              <a
                href={MAIN_URL}
                target="_blank"
                rel="noopener nofollow"
                className="text-white/30 text-xs hover:text-white/50 transition-colors duration-200 underline decoration-white/10 hover:decoration-white/30"
              >
                Main Store
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}